var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBodycodiPlusDefaultCoachProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#F4F5F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 30C32.2091 30 34 28.2091 34 26C34 23.7909 32.2091 22 30 22C27.7909 22 26 23.7909 26 26C26 28.2091 27.7909 30 30 30ZM23 34.6667V37.5C23 37.7761 23.2239 38 23.5 38H36.5C36.7761 38 37 37.7761 37 37.5V34.6667C37 34.2339 36.8716 33.8035 36.5937 33.4718C35.8098 32.5363 34.0571 31 30 31C25.9429 31 24.1902 32.5363 23.4063 33.4718C23.1284 33.8035 23 34.2339 23 34.6667Z",
    fill: "#9CA1AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodycodiPlusDefaultCoachProfile);
export default __webpack_public_path__ + "static/media/bodycodi_plus_default_coach_profile.6170a7efa48be2b6538025dece9de9f9.svg";
export { ForwardRef as ReactComponent };